import React from 'react';

const Favourites = () => (
  <div>
    <h1>Favourites</h1>
  </div>
);

export default Favourites;
